import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, inject, OnInit } from '@angular/core';
import { ViewType } from '@ortho-next/nextray-core';
import { from } from 'rxjs';
import { PrinterService } from '../../services';
import { BaseComponent } from '../../shared';
import { PrintMeasuresPageComponent } from './prt-measures-page';
import { PrintOrPlanPageComponent } from './prt-or-plan-page';


/**
* Main component of OR Plan PDF print.
*/
@Component({
	selector: 'app-or-plan-print',
	templateUrl: './prt-or-plan.component.html',
	imports: [
		PrintOrPlanPageComponent,
		PrintMeasuresPageComponent
	],
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class PrintOrPlanComponent extends BaseComponent implements OnInit, AfterViewInit {

	private readonly prtSrv = inject(PrinterService);
	private readonly element = inject(ElementRef<HTMLElement>);

	/**
	 * Today's date time.
	 */
	today = new Date();
	/**
	 * Flag indicating whether that both AP and LT views are available for printing.
	 */
	isMultiView = false;
	/**
	 * Main view type scene to print.
	 */
	viewType?: ViewType;
	/**
	 * Default view type for second pages.
	 */
	viewTypeLT = ViewType.LT;


	ngOnInit(): void {
		this.viewType = this.canvasSrv.hasAP ? ViewType.AP : ViewType.LT;
		this.isMultiView = this.canvasSrv.hasAP && this.canvasSrv.hasLT;
	}

	ngAfterViewInit(): void {
		const pages = (this.element.nativeElement as HTMLElement).querySelectorAll<HTMLElement>(':scope > *');
		from(this.prtSrv.onORPlanDataReady(pages)).subscribe();
	}

}
